import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../../components/v2/Layout";
import NewsCard from "../../../components/v2/Noticias/NewsCard";
import PageTitle from "../../../components/v2/PageTitle";
import { news } from "../../../content/news";

import style from "./styles.module.scss";

const keyI18n = "translations.news";

export default function Noticias() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />

        <div className={style.grid}>
          {news.map((item) => (
            <NewsCard item={item} key={item.slug} />
          ))}
        </div>
      </div>
    </Layout>
  );
}
